module.exports = "/static/media/all-set-desktop.1154066b.svg";